import { Helper } from '../../classes/helper'
import { cover } from '../../utility/constant/helper.constant'
import { TTerraceDepth, TTerraceWidth } from '../../utility/type/terraceCover.type'

export abstract class Model {
  /**
   * Calculates the number of front windows
   * @param width The width of the terrace cover
   * @returns The number of front windows
   */
  public static windowsFront(width: TTerraceWidth): number {
    // TODO
    switch (true) {
      case width >= 200 && width < 300:
        return 2
      case width >= 300 && width < 400:
        return 3
      case width >= 400 && width < 500:
        return 4
      case width >= 500 && width < 600:
        return 4
      case width >= 600 && width < 700:
        return 6
      case width >= 700 && width < 800:
        return 6
      case width >= 800 && width < 900:
        return 9
      case width >= 900 && width < 1000:
        return 9
      case width >= 1000:
        return 8
      default:
        return 2
    }
  }

  /**
   * Calculates the number of side windows
   * @param depth The depth of the terrace cover
   * @returns The number of side windows
   */
  public static windowsSide(depth: TTerraceDepth): number {
    // TODO
    switch (true) {
      case depth >= 200 && depth < 300:
        return 2
      case depth >= 300 && depth < 400:
        return 3
      case depth >= 400 && depth < 500:
        return 4
      case depth >= 500 && depth < 600:
        return 5
      default:
        return 2
    }
  }

  /**
   * Calculates the width of a top window
   * @param width The width of the terrace cover
   * @param windowsTotal The total required top windows
   * @returns The size of a top window
   */
  public static windowsTopWidth(
    width: TTerraceWidth,
    windowsTotal: number
  ): number {
    return width / windowsTotal
  }

  /**
   * Calculates the width of a front window
   * @param width The width of the terrace cover
   * @param windowsFrontTotal The total required front windows
   * @returns The size of a front window
   */
  public static windowsFrontWidth(
    width: TTerraceWidth,
    windowsFrontTotal: number
  ) {
    return (width - cover.bar.width) / windowsFrontTotal
  }

  /**
   * Calculates the width of a side window
   * @param depth The depth of the terrace cover
   * @param windowsSideTotal The total required side windows
   * @returns The size of a side window
   */
  public static windowsSideWidth(
    depth: TTerraceDepth,
    windowsSideTotal: number
  ): number {
    return depth / windowsSideTotal
  }

  /**
   * Calculates the number of logs for the top windows
   * @param width The width of the terrace cover
   * @returns The number of logs for the top windows
   */
  public static logsTopTotal(width: TTerraceWidth): number {
    switch (true) {
      case width >= 400 && width < 800:
        return 1
      case width >= 800 && width < 1000:
        return 2
      case width >= 1000:
        return 3
      default:
        return 0
    }
  }

  /**
   * Calculates the number of logs for the front windows
   * @param width The width of the terrace cover
   * @returns The number of logs for the front windows
   */
  public static logsFrontTotal(width: TTerraceWidth) {
    // TODO
    switch (true) {
      case width >= 200 && width < 300:
        return 1
      case width >= 300 && width < 400:
        return 2
      case width >= 400 && width < 500:
        return 3
      case width >= 500 && width < 600:
        return 3
      case width >= 600 && width < 700:
        return 5
      case width >= 700 && width < 800:
        return 5
      case width >= 800 && width < 900:
        return 8
      case width >= 900 && width < 1000:
        return 8
      case width >= 1000:
        return 7
      default:
        return 1
    }
  }

  /**
   * Calculates the number of logs for the side windows
   * @param depth The depth of the terrace cover
   * @returns The number of logs for the side windows
   */
  public static logsSideTotal(depth: TTerraceDepth): number {
    return Math.ceil(depth / 100) - 1
  }

  /**
    Method to calculate the required depth for set parameters
   * @param depth The depth of the terrace cover
   * @returns The depth of there terrace that is required for the windows
   */
  public static terraceDepth(depth: number): number {
    const terraceDepth = depth / 100 + 1
    return terraceDepth
  }

  /**
   * Method to calculate the front height
   * @param angle The angle that is set for the windows
   * @param depth The depth that is set for the windows
   * @param height The starting height that is set for the windows
   * @returns The (x, y, z) position of the front part for the windows
   */
  public static frontHeight(
    angle: number,
    depth: TTerraceDepth | number,
    height: number
  ): number {
    const roundingError = angle > 9 ? (angle - 10) * 0.5 + 0.5 : 0
    const slope = -Math.tan((angle * Math.PI) / 180)
    const gamma = 180 - 90 - angle
    const x = depth * Math.sin((gamma * Math.PI) / 180)
    const y = slope * x + height
    return y - roundingError
  }

  /**
    Calculates the angle compensation needed when the mesh is rotation around the center
   @param angle The angle of the bar
   @param depth The depth of the windows
   @return The amount of height that has to be adjusted when rotated

  */
  public static angleCompensation(angle: number, depth: TTerraceDepth): number {
    const angleCompensation = Math.tan((angle * Math.PI) / 180) * depth
    return Helper.convertToMeter(-angleCompensation / 2)
  }
}
